import { LoginDTO } from "../../../../requests/login/types";
import { AError } from "../../../../requests/types";
import {
  LOGIN_ERASE_ERROR,
  LOGIN_ERROR,
  LOGIN_NO_COOKIE_SET,
  LOGIN_SUCCESS,
  REQUEST_LOGIN,
} from "../../actions";

// ----- REQUEST ----------------------------------------------------------
type RequestLogin = {
  type: typeof REQUEST_LOGIN;
};

export const requestLogin = (): RequestLogin => ({
  type: REQUEST_LOGIN,
});

// ----- SUCCESS ---------------------------------------------------------
type SuccessLogin = {
  type: typeof LOGIN_SUCCESS;
  payload: {
    data: LoginDTO;
    isUserAdmin: boolean;
  };
};

export const successLogin = (
  data: LoginDTO,
  isUserAdmin: boolean
): SuccessLogin => ({
  type: LOGIN_SUCCESS,
  payload: { data, isUserAdmin },
});

// ----- SUCCESS ---------------------------------------------------------
type NoLoginCookieSet = {
  type: typeof LOGIN_NO_COOKIE_SET;
};

export const noLoginCookieSet = (): NoLoginCookieSet => ({
  type: LOGIN_NO_COOKIE_SET,
});

// ----- ERROR -----------------------------------------------------------
type ErrorLogin = {
  type: typeof LOGIN_ERROR;
  errors: AError;
};

export const errorLogin = (error: AError): ErrorLogin => ({
  type: LOGIN_ERROR,
  errors: error,
});

type EraseLoginError = {
  type: typeof LOGIN_ERASE_ERROR;
};

export const eraseLoginError = (): EraseLoginError => ({
  type: LOGIN_ERASE_ERROR,
});

export type LoginActions =
  | RequestLogin
  | SuccessLogin
  | NoLoginCookieSet
  | ErrorLogin
  | EraseLoginError;
